import { Entity } from './Entity';
import { Logger } from '../../utils/Logger';

/**
 * Manages all entities in the ECS architecture
 */
export class EntityManager {
  private static instance: EntityManager;
  private entities: Map<number, Entity>;
  private logger: Logger;

  private constructor() {
    this.entities = new Map();
    this.logger = Logger.getInstance();
  }

  public static getInstance(): EntityManager {
    if (!EntityManager.instance) {
      EntityManager.instance = new EntityManager();
    }
    return EntityManager.instance;
  }

  /**
   * Create a new entity
   */
  public createEntity(): Entity {
    const entity = new Entity();
    this.entities.set(entity.getId(), entity);
    return entity;
  }

  /**
   * Remove an entity
   */
  public removeEntity(entity: Entity): void {
    this.entities.delete(entity.getId());
  }

  /**
   * Get an entity by ID
   */
  public getEntity(id: number): Entity | undefined {
    return this.entities.get(id);
  }

  /**
   * Get all entities
   */
  public getAllEntities(): Entity[] {
    return Array.from(this.entities.values());
  }

  /**
   * Clear all entities
   */
  public clear(): void {
    this.entities.clear();
  }
}
